import { render, staticRenderFns } from "./AutoInfracaoTo.vue?vue&type=template&id=648bb7ba&lang=pug"
import script from "./AutoInfracaoTo.vue?vue&type=script&lang=js"
export * from "./AutoInfracaoTo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports